<!--
Author:
Create Time: 2020-04-10 14:06:26
Description: 收费标准参照框
-->
<template>
  <el-dialog
    :title="title"
    class="com-populregister-ref"
    top="10vh"
    :before-close="handleCancel"
    :close-on-click-modal="false"
    v-dialogDrag
    :modal="false"
    :width="width"
    v-bind="{...$props, ...$attrs}"
  >
    <el-form :inline="true" :model="condition" size="mini" style="margin-top: 20px;" label-suffix=":">
      <el-form-item v-if="!title == '选择收费标准'" label="服务中心">
        <!-- <el-input v-model="condition.name" placeholder="模糊查询"></el-input> -->
        <treeSelect
          :data="servicenterOption"
          :top="false"
          v-model="condition.servicenterId"
          label="name"
          :onlyChildren="true"
          clearable
        ></treeSelect>
      </el-form-item>
      <el-form-item label="收费项目">
        <!-- <el-input v-model="condition.phone" placeholder="模糊查询"></el-input> -->
        <treeSelect
          :data="proCostsubjTreeData"
          :top="false"
          v-model="condition.costsubjId"
          label="name"
          :onlyChildren="true"
          clearable
        ></treeSelect>
      </el-form-item>

      <el-form-item label="收费标准名称">
        <el-input v-model="condition.name" placeholder="精确查询"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <div style="padding: 0px 10px;height:360px; padding-bottom: 2em;">
      <el-table
        :data="pageData.list"
        border
        class="table"
        ref="multipleTable"
        align="center"
        height="100%"
        @row-click="handleRowClick"
        @selection-change="handleSelectionChange"
        :key="multiple ? 'multiple' : 'radio'"
      >
        <el-table-column
          width="50"
          align="center"
          show-overflow-tooltip
          v-if="!multiple"
        >
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="selectedRowId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          width="50"
          align="center"
          show-overflow-tooltip
          v-if="multiple"
          type="selection"
        ></el-table-column>

        <el-table-column
          prop="code"
          align="center"
          label="编码"
          min-width="50"
          show-overflow-tooltip
          sortable
        ></el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="收费标准名称"
          min-width="150"
          show-overflow-tooltip
          sortable
        ></el-table-column>
        <el-table-column
          prop="calcType"
          align="center"
          label="计算方式"
          min-width="50"
          show-overflow-tooltip
          sortable
        ></el-table-column>
        <el-table-column
          prop="price"
          align="center"
          label="单价"
          min-width="50"
          show-overflow-tooltip
          sortable
        ></el-table-column>
        <el-table-column
          prop="accuracy"
          align="center"
          label="精度"
          min-width="50"
          show-overflow-tooltip
          sortable
        ></el-table-column>
        <el-table-column
          prop="remark"
          align="center"
          label="备注"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>
      </el-table>
      <div data-ignore-class="pagination">
        <pagination
          data-ignore-style="float:right"
          style="text-align: right;"
          :page-list="pageData"
          @pagesearch="handlePage"
        ></pagination>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import accounting from "accounting"; // 数字格式

function newSearchCondition() {
  return {
    // 查询列表数据的条件
    loginUser: window.sessionStorage.getItem("userId"),

    servicenterId: undefined,
    costsubjId: undefined,
    name: undefined,
    orgId: undefined,
    costnormIds: [],
  };
}

export default {
  name: "proCostnormRef",
  data() {
    return {
      servicenterOption: [], //服务中心
      proCostsubjTreeData: [], //收费项目
      condition: newSearchCondition(),
      pageData: {
        list: [],
        pageNumber: 1,
        pageSize: 10,
        totalCount: 0,
        totalPage: 0
      },
      selectedRowId: "", //单选列表选中的id

      selection: [],
      mVisible: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.condition = newSearchCondition();
        if (this.conditions != undefined) {
          this.condition.orgId = this.conditions.orgId;
        }
        if(this.costnormIds.length!=0){
          this.condition.costnormIds = this.costnormIds;
        }

        this.search().then(() => this.mVisible = true);

        this.selectedRowId = null;
        this.selection = [];
      }else {
        this.mVisible = false;
      }
    }
  },
  props: {
    custAddCheck: {
      //客户档案新增属性：true-排除数据空校验
      type: Boolean,
      default: () => false
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    width: {
      type: String,
      default: () => "80%"
    },
    conditions: {
      type: Object,
      default: () => {}
    },
    costnormIds:{
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: () => ""
    },
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      if (
        this.multiple
          ? this.selection.length === 0
          : !this.selectedRowId && !this.custAddCheck
      ) {
        this.$message.warning("请选择数据");
        return;
      }
      this.$emit(
        "confirm",
        this.multiple
          ? this.selection
          : this.pageData.list.find(item => item.id === this.selectedRowId)
      );
    },
    search() {
      this.pageData.pageNumber = 1;
      return this.getData(this.pageData.pageNumber, this.pageData.pageSize);
    },
    getData(number, size) {
      return this.$http
        .post(this.api.ProCostnormQueryList, {
          condition: this.condition,
          number: number,
          size: size
        })
        .then(res => {
          if (res.data && res.data.code === "200") {
            this.pageData.list = res.data.body.records;
            this.pageData.totalCount = res.data.body.total;
            this.pageData.totalPage = res.data.body.pages;
          }
        });
    },
    handlePage(number, size) {
      this.pageData.pageNumber = number;
      this.pageData.pageSize = size;
      this.getData(this.pageData.pageNumber, this.pageData.pageSize);
    },
    //行选择
    handleRowClick(row) {
      this.selectedRowId = row.id;
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    }
  },
  mounted() {
    //获取收费项目
    this.$http
      .post(this.api.ProCostsubjQueryTreeList, {
        condition: this.condition
      })
      .then(res => {
        if (res.data.code === "200") {
          let newTreeData = [
            {
              id: "",
              name: "收费项目",
              children: res.data.body.proCostsubjList,
              isChildren: 1
            }
          ];
          this.proCostsubjTreeData = res.data.body.proCostsubjList;
        }
      });

    //获取服务中心
    this.$http
      .post(this.api.proServicenterGetTree, {
        condition: this.condition
      })
      .then(res => {
        if (res.data.code == "200") {
          this.servicenterOption = res.data.body.proServicenterList;
        } else {
          this.$message.warning(res.data.body);
        }
      });
  }
};
</script>

<style scoped lang="less">
// .com-populregister-ref {}
/deep/ .el-table__fixed /deep/ .el-table__fixed-body-wrapper{
  height: 285px !important;
}
/deep/ .is-scrolling-none{
  height: 285px !important;
}
@media screen and (min-width: 1600){
 /deep/ .el-table__fixed /deep/ .el-table__fixed-body-wrapper{
    top: 66px !important;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/proCostnormRegister/proCostnormRef.vue